<section class="cm-section">
  <div class="cm-container">
    <app-wp-page-content page="whistleblowing"></app-wp-page-content>
  </div>
</section>
